import HomePage from './home';

// Main page entry component for the root route
export default HomePage;
